import React, { Component } from "react";
import styles from "./logisticReports.module.scss";
import { MapContainer, TileLayer, Marker, Circle } from "react-leaflet";
import { withMapControl } from "../../../shared/containers/containerMapControl";
import L from "leaflet";
import { ControlPointIcon } from "../ControlPoints/ControlPointIcon";

class LogisticReportsControlPointMap extends Component {
  render() {
    const { mapBaseLayer, controlPoint, height = 300 } = this.props;

    if (controlPoint === null) return null;

    const svgIcon = L.divIcon({
      html: `<div>${ControlPointIcon.getIcon("black")}</div>`,
      className: "svg-icon",
      iconSize: [26, 26],
      iconAnchor: [6, 25],
    });

    return (
      <MapContainer
        key={`${controlPoint.id}`}
        center={[controlPoint.latitude, controlPoint.longitude]}
        zoom={15}
        maxZoom={mapBaseLayer.maxZoom}
        minZoom={3}
        crs={mapBaseLayer.crs}
        zoomControl={true}
        attributionControl={false}
        doubleClickZoom={false}
        scrollWheelZoom={false}
        dragging={false}
        animate={true}
        easeLinearity={0.35}
        className={styles.controlPointsReportItemMap}
      >
        {mapBaseLayer.url.map((_url, index) => {
          return <TileLayer key={mapBaseLayer.name + index} url={_url} updateWhenIdle={true} maxZoom={mapBaseLayer.maxZoom} />;
        })}

        <Marker draggable={false} icon={svgIcon} position={[controlPoint.latitude, controlPoint.longitude]}></Marker>

        {controlPoint.radius > 0 ? (
          <Circle
            key={`${controlPoint.radius} ${controlPoint.latitude} ${controlPoint.longitude}`}
            center={[controlPoint.latitude, controlPoint.longitude]}
            radius={Number(controlPoint.radius)}
          />
        ) : null}

        {this.props.children}
      </MapContainer>
    );
  }
}

export default withMapControl(React.memo(LogisticReportsControlPointMap));
